const BankRecordMatchedResourceStatusType = {
	AUTO_MACH: 'AUTO_MATCH',
	MANUAL_MATCH: 'MANUAL_MATCH',
	BAD_AUTO_MATCH: 'BAD_AUTO_MATCH'
};

export default BankRecordMatchedResourceStatusType;
